import React from "react";
import { Row, Col } from "react-bootstrap";
import { ToastContainer } from "react-toastify";
import "./ProductText.css";
import { useNavigate } from "react-router-dom";
import notify from "../../../Notifcation";
const ProductText = ({ dataa, userData, idproduct }) => {
  const navegate = useNavigate();
  const checkUser = () => {
    if (userData && userData.user_type === "client") {
      navegate("/user/paymentmethods");
      localStorage.setItem("id_car", idproduct.id);
    } else {
      notify("من فضلك قم بتسجيل الدخول اولاً  ", "error");
      setTimeout(() => {
        navegate("/login");
      }, 3000);
    }
  };
  return (
    // {dataa}

    <div>
      {dataa && dataa.id ? (
        <>
          <Row>
            <Col md="8" className="mt-4">
              <div className="cat-text d-inline">نوع السيارة :</div>
              <div className="barnd-text d-inline mx-1">
                {dataa.category.name}
              </div>
            </Col>
          </Row>
          <Row>
            <Col md="8" className="mt-4">
              <div className="cat-text d-inline">الموديل :</div>
              <div className="barnd-text d-inline mx-1">{dataa.model}</div>
            </Col>
          </Row>
          <Row>
            <Col md="8" className="mt-4">
              <div className="cat-text d-inline">سنة الصنع :</div>
              <div className="barnd-text d-inline mx-1">{dataa.year_car}</div>
            </Col>
          </Row>
          <Row>
            <Col md="8" className="mt-4">
              <div className="cat-text d-inline">رقم الشاسية :</div>
              <div className="barnd-text d-inline mx-1">
                {dataa.chassis_number}
              </div>
            </Col>
          </Row>
          <Row>
            <Col md="8" className="mt-4">
              <div className="cat-text d-inline">نوع الملكية :</div>
              <div className="barnd-text d-inline mx-1">
                {dataa.car_type === "F"
                  ? "اول مالك"
                  : dataa.car_type === "D"
                  ? "معاقين"
                  : dataa.car_type === "Z"
                  ? "الزيرو"
                  : null}
              </div>
            </Col>
          </Row>
          <Row>
            <Col md="8" className="mt-4">
              <div className="cat-text d-inline">السعر :</div>
              <div className="barnd-text d-inline mx-1">{dataa.price} جنية</div>
            </Col>
          </Row>
          <Row>
            <Col md="8" className="mt-1 d-flex"></Col>
          </Row>
          {/* <Row className="mt-4">
        <div className="cat-text">الكميه المتاحه </div>
        <div className="cat-text d-block">{item.quantity} </div>
      </Row> */}
          <Row className="mt-4">
            <div className="cat-text">المواصفات :</div>
          </Row>
          <Row className="mt-2">
            <Col md="10">
              <div className="product-description d-inline">
                {dataa.description}
              </div>
            </Col>
          </Row>
          {dataa.video !== "" ? (
            <Row className="mt-2">
              <Col md="12">
                <div className="product-description d-inline">
                  <iframe
                    title="myFramesd"
                    width="80%"
                    height="500"
                    src={`https://www.youtube.com/embed/${dataa.video}`}
                  ></iframe>
                </div>
              </Col>
            </Row>
          ) : null}

          <Row className="mt-4">
            <Col md="12">
              {/* {item.priceAfterDiscount >= 1 ? (
            <div className="product-price d-inline px-3 py-3 border">
              <span style={{ textDecorationLine: "line-through" }}>
                {" "}
                {item.price}
              </span>{" "}
              {item.priceAfterDiscount} جنية
            </div>
          ) : (
            <div className="product-price d-inline px-3 py-3 border">
              <span> {item.price}</span> جنية{" "}
            </div>
          )} */}
              {userData && userData.user_type === "admin" ? null : userData &&
                userData.user_type === "consultant" ? null : (
                <div
                  className="product-cart-add px-3 py-3 d-inline mx-3"
                  onClick={checkUser}
                >
                  اطلب الأن
                </div>
              )}
            </Col>
          </Row>
          <ToastContainer />
        </>
      ) : null}
    </div>
  );
};

export default ProductText;
